/* src/app/location-users/location-user-grid/user-access/user-access.component.scss */
.role-selection {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 16px;
  padding-top: 17px;
  padding-bottom: 17px;
  position: relative;
}
.role-selection.admin {
  background-color: #8CDACD;
  outline: 1px solid #8CDACD;
}
.role-selection.view-edit {
  background-color: #7191BE;
  outline: 1px solid #7191BE;
}
.role-selection.view-only {
  background-color: #CDD7E4;
  outline: 1px solid #CDD7E4;
}
.role-selection.no-access {
  background-color: white;
  outline: 1px solid white;
}
.role-selection ::ng-deep select {
  font-weight: bold;
  font-size: 14px !important;
  color: black;
}
.btn-text-below {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.user-mgmt-btn {
  height: 35px;
  width: 35px;
  border-radius: 4px;
  border: 1px solid #757575;
  background-color: white;
}
.approve-btn {
  color: #64A70B;
}
.deny-btn {
  color: #C91A13;
}
.error-highlight {
  border: 2px solid #C91A13;
}
.error-icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e638" !important;
  color: #C91A13;
  position: absolute;
  top: calc(50% - 0.7em);
  right: 0.1rem;
}
.text-error {
  color: #C91A13;
}
.info {
  position: absolute;
  right: 1px;
  top: 1px;
  width: 13px;
  height: 13px;
  visibility: hidden;
}
.role-selection:hover .info {
  transition: visibility 0s ease 500ms;
  visibility: visible;
}
.info::after {
  font-family: "upsicons", fantasy !important;
  content: "\e646" !important;
  color: black;
  position: absolute;
  right: 0px;
  top: -3px;
}
/*# sourceMappingURL=user-access.component.css.map */
